import { MDBCardBody, MDBCardText, MDBCardTitle } from "mdb-react-ui-kit";
import { FC } from "react";
import { starsArray } from "@/utils/star-utils";
import styles from "../../../../styles/home/Home.CardTour.module.scss";
import contactsSvg from "../../../../utils/svg-icon/contacts";

const CardBody: FC<{
    title: string;
    duration: number;
    rating: number;
    reviewsCount: number;
    nightDuration: number;
    destinationCount: number;
    isSmall: boolean;
    className: string;
    handleClick?: () => void;
}> = ({
    title,
    duration,
    nightDuration,
    rating,
    reviewsCount,
    destinationCount,
    isSmall,
    className = "",
    handleClick,
}) => {
    const { FlagLine, ClockLine } = contactsSvg;

    return (
        <MDBCardBody
            className={`d-flex flex-column pb-0 ${className}`}
            onClick={handleClick}
            style={{
                cursor: "pointer",
                padding: "0px 23px",
                paddingTop: "0px",
                paddingBottom: "18px",
                justifyContent: "space-evenly",
                flex: 2,
                marginBottom: "0px",
                gap: "5px",
                height: "115px",
            }}
        >
            <div style={{ flex: 0.7 }}>
                <MDBCardTitle
                    className={`${
                        isSmall ? styles.textTitleSmall : styles.textTitle
                    } text-start fw-bold`}
                    title={title}
                >
                    {title}
                </MDBCardTitle>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    flexGrow: 1,
                    gap: "0px",
                    marginTop: "0px",
                    marginBottom: "5px",
                    height: "65px",
                    color: "rgba(79, 79, 79, 1)",
                    width: "188px",
                }}
            >
                <div
                    className="d-flex justify-content-start align-items-center"
                    style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                    }}
                >
                    {!!reviewsCount && (
                        <>
                            {starsArray(rating)}

                            <MDBCardText
                                className={`${
                                    isSmall
                                        ? styles.captionSmall
                                        : styles.caption
                                } d-flex m-0 fw-bold`}
                            >
                                {Number(rating)}
                            </MDBCardText>
                        </>
                    )}
                </div>
                <div>
                    <MDBCardText
                        className={`${
                            isSmall ? styles.captionSmall : styles.caption
                        } d-flex m-0`}
                    >
                        <ClockLine
                            className="me-1"
                            width="15"
                            height="15"
                            viewBox="0 -3 25 25"
                        />
                        {`${duration} days ${nightDuration} nights`}
                    </MDBCardText>
                    <MDBCardText
                        className={`${
                            isSmall ? styles.captionSmall : styles.caption
                        }`}
                    >
                        <FlagLine
                            className="me-1"
                            width="15"
                            height="15"
                            viewBox="0 -3 25 25"
                        />
                        {destinationCount} Destinations
                    </MDBCardText>
                </div>
            </div>
        </MDBCardBody>
    );
};

export default CardBody;
